import React from "react";
import { Box } from "@mui/material";

const HandBook = () => {
  return (
    <Box sx={{ width: "100vw", height: "100vh" }}>
      <iframe
        src="/handbook/SAMARTH_Handbook.html"
        title="Handbook"
        style={{
          width: "100%",
          height: "100%",
          border: "none",
        }}
      />
    </Box>
  );
};

export default HandBook;
